import { render, staticRenderFns } from "./SettingsIncome.vue?vue&type=template&id=5d4dc0b3&"
import script from "./SettingsIncome.vue?vue&type=script&lang=js&"
export * from "./SettingsIncome.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIncome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports